import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Calendar, Clock, User, Settings } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isCoordinatrice } = useAuth();

  const navItems = [
    { path: '/', icon: Home, label: 'Accueil' },
    { path: '/planning', icon: Calendar, label: 'Planning' },
    { path: '/heures', icon: Clock, label: 'Heures' },
    { path: '/profil', icon: User, label: 'Profil' },
  ];

  if (isCoordinatrice) {
    navItems.splice(3, 0, { path: '/gestion', icon: Settings, label: 'Gestion' });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="flex justify-around items-center h-16">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive ? 'text-primary' : 'text-gray-500'
              }`}
            >
              <Icon size={24} className="mb-1" />
              <span className="text-xs font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default Navbar;
